import Papa from 'papaparse'
import api from '@/api'

if (!File.prototype.getExtension) {
    File.prototype.getExtension = function () {
        return this.filename.split('.').pop()
    }
}

if (!File.prototype.getFilenameWithoutExtension) {
    File.prototype.getFilenameWithoutExtension = function () {
        var name = this.name.split('.').pop()
    }
}

if (!File.prototype.toBase64) {
    File.prototype.toBase64 = function () {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(this)
            reader.onload = () => resolve(reader.result)
            reader.onerror = (error) => reject(error)
        })
    }
}

if (!File.prototype.download) {
    File.prototype.download = function () {
        api.downloadBlob(this, this.name)
    }
}

if (!File.prototype.readAsTextWithoutBom) {
    File.prototype.readAsTextWithoutBom = function () {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader()
            fileReader.onload = function (e) {
                var content = e.target.result.trim()
                if (content.charCodeAt(0) === 0xfeff) {
                    content = content.slice(1)
                }
                resolve(content)
            }
            fileReader.onerror = (error) => reject(error)
            fileReader.readAsText(this, 'UTF-8')
        })
    }
}

if (!File.prototype.readCsvAsBinaryString) {
    File.prototype.readCsvAsBinaryString = async function () {
        var csvString = await this.readAsTextWithoutBom()
        var results = Papa.parse(csvString, {
            header: true, // Use the first row as field names
            dynamicTyping: true, // Convert strings to numbers or booleans if possible
            skipEmptyLines: true // Ignore lines with no content
        })
        return results.data.map((record) => {
            delete record.__parsed_extra
            return record
        })
    }
}
